import { type Readable, writable } from "svelte/store";
import { page } from '$app/stores';
import { activityService } from "$lib/service/supabase/activity.service";
import { currentLessonId } from "./currentLesson.store";

export const createLastWatchedStore: () => Readable<number | null> = () => {
  const { set, subscribe } = writable<number | null>(null, () => {
    const unsubscribe = page.subscribe(async ($page) => {
      const innerUnsubscribe = currentLessonId.subscribe(async ($currentLessonId) => {
        if (!$page?.data?.session?.user.id) return;
        if (!$currentLessonId) return;

        const lastVideoPosition = await activityService
          .getLastVideoPosition($page.data.session?.user.id, $currentLessonId);

        set(lastVideoPosition);
      })

      return () => innerUnsubscribe();
    })

    return () => unsubscribe();
  });

  return {
    subscribe
  };
};

export const lastWatched = createLastWatchedStore();

